import { connect } from 'react-redux'
import {
  branch,
  compose,
  renderNothing,
  setDisplayName,
  setPropTypes
} from 'recompose'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import withQueryParams from './withQueryParams'

const withPreviewAddressFromId = compose(
  setDisplayName('withPreviewAddressFromId'),
  withQueryParams,
  setPropTypes({
    id: PropTypes.string.isRequired
  }),
  connect((state, { id }) => ({
    address: get(state, ['homePreview', id, 'data', 'address'])
  })),
  branch(({ address }) => !address, renderNothing)
)

export default withPreviewAddressFromId
